import {
  Line,
  ProgressWrapper,
  ProgressContainer,
  Step,
} from "./ProgressBarStyles";

interface ProgressBarProps {
  totalSteps: number;
  currentStep: number;
}

const ProgressBar = ({ totalSteps, currentStep }: ProgressBarProps) => {
  return (
    <ProgressWrapper>
      <Line />
      <ProgressContainer>
        {Array.from({ length: totalSteps }, (_, i) => (
          <Step key={i} $active={i <= currentStep} />
        ))}
      </ProgressContainer>
    </ProgressWrapper>
  );
};

export default ProgressBar;
